import React from "react";
import { Statistic } from "antd";
export const StatsCardDefault = (props) => {
  const { record, field } = props;
  return (
    <Statistic
      {...props}
      title={field}
      value={(record[field] && record[field]) || "Unknown"}
      valueStyle={record[field] ? {} : { color: "#cf1322" }}
    />
  );
};
export const StatsCardCurrency = (props) => {
  const { record, field } = props;
  return (
    <Statistic
      {...props}
      title={field}
      precision={2}
      value={(record[field] && record[field]) || "Unknown"}
      valueStyle={record[field] ? { color: "#3f8600" } : { color: "#cf1322" }}
      suffix={record["Currency Of Total Amount"]}
    />
  );
};
